import React from 'react';
import { Col, DatePicker, Form, Input, Row, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const InfoSection = () => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Info')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item
          label={t('Titolo')}
          name='title'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item
          label={t('Categorie')}
          name='Categorie'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select placeholder={t('Categorie')}>
            <Select.Option>Lorem.</Select.Option>
            <Select.Option>Lorem.</Select.Option>
            <Select.Option>Lorem.</Select.Option>
            <Select.Option>Lorem.</Select.Option>
          </Select>
        </Form.Item>
      </Col>
      <Col offset={6} span={9}>
        <Form.Item
          label={t('Data pubblicazione')}
          name='Data pubblicazione'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <DatePicker format={'DD MMMM YYYY'} style={{ width: '100%' }} />
        </Form.Item>
      </Col>
      <Col offset={6} span={9}>
        <Form.Item
          label={t('Insegna')}
          name='Insegna'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select placeholder={t('Village')}>
            <Select.Option>Lorem.</Select.Option>
            <Select.Option>Lorem.</Select.Option>
            <Select.Option>Lorem.</Select.Option>
            <Select.Option>Lorem.</Select.Option>
          </Select>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(InfoSection);
